import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import Validators from './validators'
import { BaseManipStateFn, BaseTableState } from './base'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)

export default (store) => {
  class ManipState extends BaseManipStateFn(store) {
    requiredOptions = [
      linkConst.LOAD_OPTIONS.films,
      store.loadEnumOptions('UploadTypes')
    ]

    onLoaded (entity) {
      super.onLoaded(entity)
    }

    prepareNew () {
    }

    onSaved (saved) {
      super.onSaved(saved)
      store.markDirty(linkConst.LINK_YOUTUBE_ASSETS)
    }

    createtitle = store.__(linkConst.LINK_YOUTUBE_ASSETS_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_CREATE)
    edittitle = store.__(linkConst.LINK_YOUTUBE_ASSETS_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_EDIT)
    timeRestriction = 'vatrates'
    validators = {
      video_id: Validators.isMandatory(store),
      asset_id: Validators.isMandatory(store),
      asset_name: Validators.isMandatory(store),
      asset_type: Validators.isMandatory(store),
      asset_created_dt: Validators.isMandatoryDate(store),
      _global: (vals, errors) => {
      }
    }
  }

  class TableState extends BaseTableState {
    attrs = [
      'id', 'asset_id', 'title', 'asset_name', 'asset_created_dt', 'asset_type', 'note', '_actions_'
    ]

    headertitles = [
      store.__('ID'), store.__('asset ID'), store.__('film title'), store.__('asset name'),
      store.__('created date'), store.__('asset type'), store.__('note'), store.__('actions')
    ]

    title = store.__(linkConst.LINK_YOUTUBE_ASSETS_TITLE)
    defaultSort = linkConst.DEFAULT_SORT[linkConst.LINK_YOUTUBE_ASSETS]

    init () {
      store.loadEnumOptions('UploadTypes')
      return super.init()
    }
  }

  return { ManipState, TableState }
}
